<mat-dialog-content>
  <div class="report_popup_overlay" id="report_popup_overlay">
    <div class="report_popup">
      @if (reportData?.popupTitle) {
        <div class="report_title">{{reportData?.popupTitle}}
          <a class="material-icons" mat-dialog-close>close</a>
        </div>
      }
      <div class="avail_fees">
        <div class="avail_create_pop">
          <div class="tabbed-container">

            <div class="avail_form_header disabled">
              <div class="fee_create_flex">
                @if ((appliedReportFilterDetails | json) !== '{}') {
                  <div class="fliter_icon_clear filter_pos_remove" (click)="clearReportFilterOption()">
                    <div class="clear_btn tooltip">
                      <svg width="20" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="myPath" d="M4.125 5.125C4.125 4.57271 4.57272 4.125 5.125 4.125H16.875C17.4273 4.125 17.875 4.57272 17.875 5.125V6.76634C17.875 7.03156 17.7696 7.28591 17.5821 7.47345L12.8207 12.2349C12.6331 12.4224 12.5278 12.6768 12.5278 12.942V14.8194L9.47222 17.875V12.942C9.47222 12.6768 9.36687 12.4224 9.17933 12.2349L4.41789 7.47345C4.23036 7.28591 4.125 7.03156 4.125 6.76634V5.125Z" stroke="#555555" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
                        <circle id="myPath1" cx="17.5" cy="14.5" r="4.5" fill="#555555" />
                        <path id="myPath2" d="M15.6992 12.7L19.4992 16.5" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                        <path id="myPath2" d="M15.6992 16.5L19.4992 12.7" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                      </svg>
                      <span class="tooltiptext Clear-tooltip">Clear filter</span>
                    </div>
                  </div>
                }
              </div>
            </div>

            <div class="tab-content">
              <div class="tab-pane">
                <div class="campus_avail_table campus_fees_table">
                  <table mat-table [dataSource]="dataSource()" matSort (matSortChange)="sortReportTableChanges($event)" class="mat-elevation-z8">
                    <ng-container matColumnDef="reportTitle">
                      <th mat-header-cell *matHeaderCellDef>
                        <span class="heading_name">REPORT TITLE</span>
                        <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by title"></span>
                        <span class="filter_hover">
                          <div class="filter_column">
                            @if (!appliedReportFilterDetails['reportTitle']) {
                              <button class="fliter_icon" (click)="fetchAjaxRefData('reportTitle','Report title', 'AJAX')"><img [src]="imageConst.filterIcon" alt="Filter Icon"></button>
                            }
                            @if (appliedReportFilterDetails['reportTitle']) {
                              <button class="fliter_icon_clear" (click)="clearReportFilterOption('reportTitle')">
                                <div class="tooltip">
                                  <img [src]="imageConst.clearFilterIcon" alt="Filter Icon" width="20">
                                  <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                </div>
                              </button>
                            }
                          </div>
                          @if (hideShowFilterOption() && filterDetails()?.filterId === 'reportTitle') {
                            <app-manage-filter [filterDetails]="filterDetails()"
                            (closeFilterPopup)="closeFilterPopup()" (searchIntakeFilter)="searchReportFilterDetails($event)"></app-manage-filter>
                          }
                        </span>
                      </th>
                      <td mat-cell *matCellDef="let element"> {{element.reportTitle}}
                        @if ((element?.errorManual?.toLowerCase() === 'system error')) {
                          <span class="input_help_warning">
                            <span class="material-icons-outlined warning_tooltip">
                              <img [src]="imageConst.warningIcon" alt="warning" width="14" height="14">
                              <span class="help_ctnt">System error occured</span>
                            </span>
                          </span>
                        }
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="errorManual">
                      <th mat-header-cell *matHeaderCellDef>
                        <span class="heading_name">REPORT STATUS</span> <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by report status"></span>
                        <span class="filter_hover">
                          <div class="filter_column">
                            @if (!appliedReportFilterDetails['errorManual']) {
                              <button class="fliter_icon" (click)="fetchAjaxRefData('errorManual','Report type', 'SELECT_BOX')"><img [src]="imageConst.filterIcon" alt="Filter Icon"></button>
                            }
                            @if (appliedReportFilterDetails['errorManual']) {
                              <button class="fliter_icon_clear" (click)="clearReportFilterOption('errorManual')">
                                <div class="tooltip">
                                  <img [src]="imageConst.clearFilterIcon" alt="Filter Icon" width="20">
                                  <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                </div>
                              </button>
                            }
                          </div>
                          @if (hideShowFilterOption() && filterDetails()?.filterId === 'errorManual') {
                            <app-manage-filter [filterDetails]="filterDetails()"
                            (closeFilterPopup)="closeFilterPopup()" (searchIntakeFilter)="searchReportFilterDetails($event)"></app-manage-filter>
                          }
                        </span>
                      </th>
                      <td mat-cell *matCellDef="let element">{{element.errorManual}} </td>
                    </ng-container>
                    <ng-container matColumnDef="uploadedBy">
                      <th mat-header-cell *matHeaderCellDef>
                        <span class="heading_name">UPLOADED BY</span>
                        <span class="filter_hover">
                          <div class="filter_column">
                            @if (!appliedReportFilterDetails['uploadedBy']) {
                              <button class="fliter_icon" (click)="fetchAjaxRefData('uploadedBy','Uploaded by', 'AJAX')"><img [src]="imageConst.filterIcon" alt="Filter Icon"></button>
                            }
                            @if (appliedReportFilterDetails['uploadedBy']) {
                              <button class="fliter_icon_clear" (click)="clearReportFilterOption('uploadedBy')">
                                <div class="tooltip">
                                  <img [src]="imageConst.clearFilterIcon" alt="Filter Icon" width="20">
                                  <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                </div>
                              </button>
                            }
                          </div>
                          @if (hideShowFilterOption() && filterDetails()?.filterId === 'uploadedBy') {
                            <app-manage-filter [filterDetails]="filterDetails()"
                            (closeFilterPopup)="closeFilterPopup()" (searchIntakeFilter)="searchReportFilterDetails($event)"></app-manage-filter>
                          }
                        </span>
                      </th>
                      <td mat-cell *matCellDef="let element"> {{element.uploadedBy}} </td>
                    </ng-container>
                    <ng-container matColumnDef="uploadedAt">
                      <th mat-header-cell *matHeaderCellDef>
                        <span class="heading_name">UPLOADED AT </span>
                      </th>
                      <td mat-cell *matCellDef="let element"> {{element.uploadedAt}} </td>
                    </ng-container>
                    <ng-container matColumnDef="download">
                      <th mat-header-cell *matHeaderCellDef>
                        <span class="heading_name">DOWNLOAD</span>
                      </th>
                      <td mat-cell *matCellDef="let element">
                        @if ((element?.errorManual?.toLowerCase() !== 'system error')) {
                          <img class="avail-icon-clr" [src]="imageConst.dowloandIcon" alt="download" (click)="downloadReport(element)">
                        }
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns">
                    </table>

                    @if ((appliedReportFilterDetails | json) !== '{}' && !totalRecordCount()) {
                      <app-no-filter-data-found [pageName]="'report'"></app-no-filter-data-found>
                    }
                  </div>

                  @if (totalRecordCount() && showTableContent()) {
                    <app-page-navigation pageName='report-details' [totalCount]='totalRecordCount()'
                    [currentPage]='currentPageNumber' (selectedPage)='getPaginationDetails($event)'></app-page-navigation>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>

